// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfr_a"};